import { aggregateDailyCosts } from './shiftCost';

function toYMD(date) {
  const y = date.getFullYear();
  const m = String(date.getMonth() + 1).padStart(2, '0');
  const d = String(date.getDate()).padStart(2, '0');
  return `${y}-${m}-${d}`;
}

export function getMondayOf(date) {
  const d = new Date(date);
  d.setHours(0, 0, 0, 0);
  const day = d.getDay();
  d.setDate(d.getDate() - (day + 6) % 7);
  return d;
}

// year: full year, month: 0-indexed (0=Jan, 11=Dec)
// Returns { year, month, weeks: (string|null)[][], allMondays: string[] }
// Each week is 7 items: string "YYYY-MM-DD" if in-month, null if padding
export function getMonthCalendarGrid(year, month) {
  const firstDay = new Date(year, month, 1);
  const lastDay = new Date(year, month + 1, 0);

  const gridStart = getMondayOf(firstDay);

  // Extend to include the Sunday of the week that contains lastDay
  const lastDow = lastDay.getDay(); // 0=Sun
  const daysToSunday = lastDow === 0 ? 0 : 7 - lastDow;
  const gridEnd = new Date(lastDay);
  gridEnd.setDate(gridEnd.getDate() + daysToSunday);

  const weeks = [];
  const allMondays = [];
  const cursor = new Date(gridStart);

  while (cursor <= gridEnd) {
    const week = [];
    allMondays.push(toYMD(cursor));
    for (let i = 0; i < 7; i++) {
      const inMonth = cursor.getMonth() === month && cursor.getFullYear() === year;
      week.push(inMonth ? toYMD(cursor) : null);
      cursor.setDate(cursor.getDate() + 1);
    }
    weeks.push(week);
  }

  return { year, month, weeks, allMondays };
}

// weekShiftsMap: Map<weekStartYMD, ShiftResponse[]>
// Thin wrapper around aggregateDailyCosts for a full month's cached shifts
export function computeDailyCosts(weekShiftsMap, employees) {
  const allShifts = [];
  for (const shifts of weekShiftsMap.values()) {
    allShifts.push(...shifts);
  }
  return aggregateDailyCosts(allShifts, employees);
}

// Returns tier 0–4 relative to the month's daily maximum cost
export function costTier(costSmallestUnit, monthMax) {
  if (!monthMax || !costSmallestUnit) return 0;
  const r = costSmallestUnit / monthMax;
  if (r < 0.25) return 1;
  if (r < 0.5) return 2;
  if (r < 0.75) return 3;
  return 4;
}
